exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlegend[data-v-4627b074] {\n  color: deepskyblue;\n  text-align: center;\n  padding: 25px;\n  /* text-underline-position: under; */\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4627b074","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Dashboard/Views/Corporations/CreateCorporation.vue
// module id = M8mk
// module chunks = 0